window.initializeGoogleTracker = function () {
  (function (i, s, o, g, r, a, m) {
    i["GoogleAnalyticsObject"] = r;
    (i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = 1 * new Date());
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    "script",
    "//www.google-analytics.com/analytics.js",
    "ga"
  );

  ga("create", pageConfig["google-tracking-id"], {
    cookieDomain: pageConfig["google-domain"],
  });
  ga("set", "transport", "beacon");
  ga("send", "pageview");

  var googleUserID = pageConfig["google-user-id"];
  ga("set", "&uid", googleUserID); // Set the user ID using signed-in user_id.
  ga("set", "dimension1", googleUserID);
};

window.GoogleTrackerECommerceSend = function () {
  var cockieOrderUUID = document.cookie.replace(
      /(?:(?:^|.*;\s*)orderUUID\s*\=\s*([^;]*).*$)|^.*$/,
      "$1"
    ),
    $trackingData = document.querySelectorAll(
      "[data-google-analitycs-ecommerce-tracking]"
    );
  var orderUUID = document
    .querySelector("[data-order-uuid]")
    ?.getAttribute("data-order-uuid");
  var trackingOrders = [];

  if ($trackingData.length === 0) return;
  if (cockieOrderUUID == orderUUID) return;

  ga("require", "ecommerce");

  for (var i = 0; i < $trackingData.length; i++) {
    trackingOrders.push(
      JSON.parse(
        $($trackingData[i]).attr("data-google-analitycs-ecommerce-tracking")
      )
    );
  }

  if (trackingOrders.length > 0) {
    trackingOrders.forEach(function (trackingOrder) {
      ga("ecommerce:addTransaction", trackingOrder.order);
      trackingOrder.order_lines.forEach(function (item) {
        ga("ecommerce:addItem", item);
      });
    });

    ga("ecommerce:send");

    document.cookie = "orderUUID=" + orderUUID;
  }
};

export function pushAnalyticsData(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(data);

  return window.dataLayer;
}
